import { createFileRoute } from "@tanstack/react-router";

import { CleanControlHub } from "@/features/clean-control";

/**
 * ``/workspace/clean-control`` — Wave 2 Clean & Control cockpit.
 *
 * The surface owns its own SurfaceLayout chrome (see
 * ``CleanControlHub``), so the route file is purely a bind.
 */
export const Route = createFileRoute("/_authed/workspace/clean-control")({
  component: CleanControlHub,
});
